import TariffApi from './rest/TariffApi';

export default new TariffApi();
